module.exports = __webpack_public_path__ + "img/bg.6578c51a.png";